// extracted by mini-css-extract-plugin
export default {"textWrapped":"Text_textWrapped__kQ2pa","textPre":"Text_textPre__1Od44"};